export const lumberSize = 3650;



/** WEBPACK FOOTER **
 ** ./src/constants.js
 **/